export default __webpack_public_path__ + "static/media/icon_password.f72cbcea.svg";